import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { TBBO2TherapyReportComponent } from './tbbo2-therapy-report/tbbo2-therapy-report.component';
import { TBBO2RecoveryTimeReportComponent } from './tbbo2-recovery-time-report/tbbo2-recovery-time-report.component';
import { UserComponent } from './admin/user/user.component';
import { LandingComponent } from './landing/landing.component';
import { EditProfileComponent } from './account/edit-profile/edit-profile.component';
import { ChangePasswordComponent } from './account/change-password/change-password.component';
import { ClinicComponent } from './admin/clinic/clinic.component';
import { MachineComponent } from './admin/machine/machine.component';
import { PatientComponent } from './admin/patient/patient.component';
import {ImportDataComponent} from './admin/import-data/import-data.component';
import { from } from 'rxjs';
import { PasscodeComponent } from './admin/passcode/passcode.component';
import { ServiceCodesScanComponent } from './device/service-codes-scan/service-codes-scan.component';
import {PrivacyComponent} from './privacy/privacy/privacy.component';
import {DeleteAccountComponent} from './account/delete-account/delete-account.component';
import {ManageDeleteRequestsComponent} from './admin/manage-delete-requests/manage-delete-requests.component';
import {AuthGuard} from './util/auth/AuthGuard';

const routes: Routes = [
  { path: '', component: LoginComponent, data: { allowed: false } },
  { path: 'landing', component: LandingComponent, data: { allowed: false } },
  { path: 'tbbo2therapyreport', component: TBBO2TherapyReportComponent, data: { allowed: false } },
  { path: 'tbbo2recoverytimereport', component: TBBO2RecoveryTimeReportComponent, data: { allowed: false } },
  { path: 'manageusers', component: UserComponent, data: { allowed: false } },
  { path: 'managedeleterequests', component: ManageDeleteRequestsComponent, data: { allowed: false } },
  { path: 'manageclinics', component: ClinicComponent, data: { allowed: false } },
  { path: 'managemachines', component: MachineComponent, data: { allowed: false } },
  { path: 'managepatients', component: PatientComponent, data: { allowed: false } },
  { path: 'managepasscode', component: PasscodeComponent, data: { allowed: false } },
  { path: 'importdata',component:ImportDataComponent,data:{allowed:false}},
  { path: 'editprofile', component: EditProfileComponent, data: { allowed: false } },
  { path: 'requestdeleteprofile', component: DeleteAccountComponent, data: { allowed: false } , canActivate: [AuthGuard]},
  { path: 'changepassword', component: ChangePasswordComponent, data: { allowed: false } },
  { path: 'servicecodesscan', component: ServiceCodesScanComponent, data: { allowed: false } },
  { path: 'privacy', component: PrivacyComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
